export default function(state = {}, action) {
  const typeMap = {
    NOT_FOUND_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    NOT_FOUND_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.notFoundPage
      };
    },
    NOT_FOUND_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.notFoundPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
